import { PackageNamespace } from '@tablekit/package-namespace';
var languageSelectorThemeNamespace = PackageNamespace.LanguageSelector;
var languageSelectorClassicTheme = {};
var languageSelectorDarkTheme = languageSelectorClassicTheme;
export { languageSelectorClassicTheme, languageSelectorDarkTheme, languageSelectorThemeNamespace };
